import React, { useEffect, useState, useCallback } from 'react';
import { green, red, yellow, orange } from '@ant-design/colors';
import { Button, Table, Alert, Spin, Progress, Input, Select, message, Space, Tooltip, Popconfirm, Tag } from 'antd';
import { InboxOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { ClearOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { getArbolDirectorios } from '../../services/dashboardInicial/getArbolDirectorios';
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../store/auth/selectors';
import './Participantes.css';
import { getParticipantes, deleteParticipante, getSoportesBulk } from '../../services/participant/participantesServices';
import getEstadoProyectoParticipanteFinal from '../../services/participant/proyectosParticipanteFinalService';
import ExportToExcelParticipantes from './exportExcelPartcipantes';
import ExportParticipantesFinales from './ExportParticipantesFinales';
import ParticipantForm from "./ParticipantForm"
import { EditOutlined, EyeOutlined, DeleteOutlined, PlusOutlined, } from "@ant-design/icons";
import { useParams } from "react-router-dom";

const { Option } = Select;

const Participantes = ({ proyectoCodigo, participantesFinales }) => {
  console.log("🚀 ~ file: Participantes.jsx:34 ~ Participantes ~ participantesFinales:",proyectoCodigo, participantesFinales)
  const { id } = useParams();
  const proyectoFiltrar = proyectoCodigo || id;
  const [participantes, setParticipantes] = useState([]);
  const [filterParticipantes, setFilterParticipantes] = useState([]);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const viewMode = 'table';
  const [listaDepartamentos, setListaDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState(null);
  const [listaMunicipios, setListaMunicipios] = useState([]);
  const [listaMunicipiosFilter, setListaMunicipiosFilter] = useState([]);
  const [selectedMunicipio, setSelectedMunicipio] = useState(null);
  const [listaProyectos, setListaProyectos] = useState([]);
  const [selectedProyecto, setSelectedproyecto] = useState(null);
  const [numeroIdentificacion, setNumeroIdentificacion] = useState(null);
  const [sortOrder, setSortOrder] = useState({});
  const [sortField, setSortField] = useState('');
  const [filteredInfo, setFilteredInfo] = useState({});
  const location = useLocation();
  const { nombre_participante } = location.state || {};
  const appName = 'participantes';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const permissionExport = permissions.priv_export === 'Y';
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';


  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedEstado, setSelectedEstado] = useState();
  const [listaImplementadores, setListaImplementadores] = useState([]);
  const [selectedImplementador, setSelectedImplementador] = useState(null);
  const [showFilters, setShowFilters] = useState(true);


  // Modal states
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [selectedParticipant, setSelectedParticipant] = useState(null);

  // Estado oarticipante final
  const [proyectoFinalActivo, setProyectoFinalActivo] = useState(false);



  const listaEstados = [
    { value: '1', label: 'Activo' },
    { value: '2', label: 'Inactivo' },
  ];

  const getUniqueByValue = (data, key) => {
    const unique = data.reduce((acc, current) => {
      if (!acc[current[key]]) {
        acc[current[key]] = current;
      }
      return acc;
    }, {});
    return Object.values(unique);
  };

  const handleDepartamentoChange = (value) => {
    setSelectedMunicipio('');
    setSelectedDepartamento(value);
    const filteredList = listaMunicipios.filter(item => item.id_departamento === value);
    setListaMunicipiosFilter(filteredList);
  };

  useEffect(() => {
    setSelectedproyecto(proyectoFiltrar);
    fetchPartcipantes();

  }, [proyectoFiltrar]);

  useEffect(() => {
    const consultarEstadoProyecto = async () => {
      if (!proyectoFiltrar) {
        setProyectoFinalActivo(false);
        return;
      }
      const response = await getEstadoProyectoParticipanteFinal(proyectoFiltrar);
      if (response.status === 200) {
        setProyectoFinalActivo(response.data.activo === true);
      } else {
        setProyectoFinalActivo(false);
      }
    };

    consultarEstadoProyecto();
  }, [proyectoFiltrar]);


  const fetchPartcipantes = useCallback(async () => {
    try {
      setLoading(true);

      // ✅ Las 3 llamadas pesadas en paralelo — antes eran secuenciales
      const [
        { data, status },
        directoriosResponse,
        soportesBulkResponse
      ] = await Promise.all([
        getParticipantes(proyectoFiltrar),
        getArbolDirectorios(),
        getSoportesBulk(proyectoFiltrar)
      ]);

      setStatus(status);

      if (status === 200) {

        const dataDirectorios = directoriosResponse.data;
        const soportesBulk = soportesBulkResponse.data; // { "cedula": { total, oid_proyecto, codigo } }

        // ── Calcula progreso para cada participante usando datos ya en memoria ──
        // ✅ Cero llamadas HTTP adicionales — todo se resuelve localmente
        const participantesConArchivo = data.map(part => {
          const updatedPart = { ...part };
          let progreso = 0;

          const carpetas = [
            { ruta: `${part.codigo}/Participantes/${part.numero_identificacion}/Cédula`, campo: 'validado_registraduria' },
            { ruta: `${part.codigo}/Participantes/${part.numero_identificacion}/Antecedentes Procuraduría`, campo: 'validado_procuraduria' },
            { ruta: `${part.codigo}/Participantes/${part.numero_identificacion}/Antecedentes Policía`, campo: 'validado_policia' },
            { ruta: `${part.codigo}/Participantes/${part.numero_identificacion}/RNMC`, campo: 'RNMC' },
            { ruta: `${part.codigo}/Participantes/${part.numero_identificacion}/Antecedentes Contraloría`, campo: 'validado_contraloria' },
          ];

          // ¿Tiene documentos en la BD? (del bulk)
          const tieneSoportesBD = (soportesBulk[part.numero_identificacion]?.total ?? 0) > 0;

          for (const { ruta, campo } of carpetas) {
            const rutaLista = transformarRutaARutaLista(ruta);
            const tieneArchivo = contieneArchivo(dataDirectorios, rutaLista) || tieneSoportesBD;

            updatedPart[campo] = tieneArchivo ? 'X' : '';
            if (tieneArchivo) progreso += 20;
          }

          updatedPart.progress = progreso;
          return updatedPart;
        });

        // ── Filtros ────────────────────────────────────────────────────────────
        const filteredData = nombre_participante
          ? participantesConArchivo.filter(part =>
            part.nombre_participante.toLowerCase().includes(nombre_participante.toLowerCase())
          )
          : participantesConArchivo;

        setParticipantes(participantesConArchivo);

        const uniqueDataProyecto = getUniqueByValue(filteredData, 'codigo');
        setListaProyectos(
          uniqueDataProyecto
            .map(item => ({ nombre_proyecto: item.proyecto, proyecto_codigo: item.codigo }))
            .sort((a, b) =>
              parseInt(a.proyecto_codigo.replace('P', ''), 10) -
              parseInt(b.proyecto_codigo.replace('P', ''), 10)
            )
        );

        const uniqueDataDepartamento = getUniqueByValue(filteredData, 'oid_departamento');
        setListaDepartamentos(uniqueDataDepartamento.map(item => ({
          id_departamento: item.oid_departamento,
          departamento: item.departamento
        })));

        const uniqueDataMunicipio = getUniqueByValue(filteredData, 'oid_municipio');
        const filtersMunicipios = uniqueDataMunicipio.map(item => ({
          id_municipio: item.oid_municipio,
          municipio: item.municipio,
          id_departamento: item.oid_departamento
        }));
        setListaMunicipios(filtersMunicipios);
        setListaMunicipiosFilter(filtersMunicipios);

        setListaImplementadores(
          getUniqueByValue(filteredData, 'Implemetador')
            .map(item => item.Implemetador || 'Sin Implementador')
            .filter((v, i, self) => self.indexOf(v) === i)
            .sort()
        );

      } else {
        setParticipantes([]);
        setFilterParticipantes([]);
      }
    } catch (e) {
      console.error(e);
      setStatus(500);
    } finally {
      setLoading(false);
    }
  }, [proyectoFiltrar, nombre_participante]);


  function transformarRutaARutaLista(ruta) {
    return ruta.split('/').filter(segment => segment);
  }

  const contieneArchivo = (dataDirectorios, nombres) => {

    let currentNode = dataDirectorios.find(node => node.name === nombres[0]);
    for (let i = 1; i < nombres.length; i++) {
      if (!currentNode || !currentNode.children) {
        return false;
      }
      currentNode = currentNode.children.find(child => child.name === nombres[i]);
    }
    if (currentNode && currentNode.children && currentNode.children.length > 0) {
      return currentNode.children.some(child => child.type === "file");
    }
    return false;
  }

  const renderErrorMessage = (status) => {
    if (status === 404) {
      return (
        <Alert type="warning" message="Advertencia" description="Lo sentimos, no se encuentran participantes disponibles para mostrar." showIcon icon={<FontAwesomeIcon icon={faExclamationTriangle} />} />
      );
    } else if (status === 500) {
      return (
        <Alert type="error" message="Error" description="Lo sentimos, ha ocurrido un error al obtener los participantes. Por favor, inténtelo de nuevo más tarde o contacte a soporte@comunix.co" showIcon icon={<FontAwesomeIcon icon={faExclamationCircle} />} />
      );
    }
  };


  const handleTableChange = (pagination, filters, sorter, extra) => {
    setSortOrder(sorter.order);
    setSortField(sorter.field);
    setFilteredInfo(filters);
  };

  const noDataConfig = {
    emptyText: (
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <InboxOutlined style={{ fontSize: '2rem' }} />
        <span>Sin resultados</span>
      </span>
    ),
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}/${month}/${year}`;
  }

  const clearAllFilters = async () => {
    setFilteredInfo({});
    setNumeroIdentificacion('');
    setSelectedproyecto(proyectoFiltrar);
    setSelectedMunicipio(null);
    setSelectedDepartamento(null);
    setSelectedEstado(null);
    setSelectedImplementador(null);
  };

  const applyFilters = useCallback((source) => {
    let filtered = [...source];

    if (nombre_participante) {
      filtered = filtered.filter(part =>
        part.nombre_participante.toLowerCase().includes(nombre_participante.toLowerCase())
      );
    }
    if (numeroIdentificacion) {
      filtered = filtered.filter(item =>
        item.numero_identificacion.includes(numeroIdentificacion)
      );
    }
    if (selectedDepartamento) {
      filtered = filtered.filter(item => item.oid_departamento === selectedDepartamento);
    }
    if (selectedMunicipio) {
      filtered = filtered.filter(item => item.oid_municipio === selectedMunicipio);
    }
    if (selectedProyecto) {
      filtered = filtered.filter(item => item.codigo === selectedProyecto);
    }
    if (selectedEstado) {
      filtered = filtered.filter(item => item.estado === selectedEstado);
    }
    if (selectedImplementador) {
      filtered = filtered.filter(item => item.Implemetador === selectedImplementador);
    }

    return filtered;
  }, [nombre_participante, numeroIdentificacion, selectedDepartamento,
    selectedMunicipio, selectedProyecto, selectedEstado, selectedImplementador]);

  useEffect(() => {
    setFilterParticipantes(applyFilters(participantes));
  }, [participantes, applyFilters]);


  const columns =
    [
      {
        title: 'DATOS BASICOS',
        children: [
          {
            title: "Acciones",
            width: 100,
            key: "actions",
            render: (_, record) => (
              <Space size="small">
                {/* Ver: siempre disponible */}
                <Tooltip title="Ver">
                  <Button
                    type="text"
                    icon={<EyeOutlined />}
                    onClick={() => handleView(record)}
                    size="small"
                  />
                </Tooltip>

                {/* Editar: solo si tiene permiso */}
                {permissionUpdate && (
                  <Tooltip title="Editar">
                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      onClick={() => handleEdit(record)}
                      size="small"
                    />
                  </Tooltip>
                )}

                {/* Eliminar: solo si tiene permiso */}
                {permissionDelete && record.estado !== '2' && record.estado !== 2 && (

                  <Popconfirm
                    title="¿Seguro que deseas eliminar este participante?"
                    okText="Sí"
                    cancelText="No"
                    onConfirm={() => handleDeleteConfirm(record.oid)}
                  >
                    <Tooltip title="Eliminar">
                      <Button
                        type="text"
                        icon={<DeleteOutlined />}
                        size="small"
                        danger
                      />
                    </Tooltip>
                  </Popconfirm>
                )}
              </Space>
            ),
          }
          ,
          {
            title: '#',
            key: 'index',
            width: 50,
            align: 'center',
            render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
          },
          {
            title: 'Nombre completo',
            dataIndex: 'nombre_participante',
            key: 'nombre_participante',
            width: 200,
            align: 'left',
          },
          {
            title: 'Tipo de Identificación',
            dataIndex: 'tipo_identificacion',
            key: 'tipo_identificacion',
            width: 250,
            align: 'left',

          },
          {
            title: 'Número de Identificación',
            dataIndex: 'numero_identificacion',
            key: 'numero_identificacion',
            width: 250,
          },

          {
            title: 'Sexo',
            dataIndex: 'sexo',
            key: 'sexo',
            width: 100,
            align: 'center'
          },
          {
            title: 'Estado',
            dataIndex: 'estado',
            key: 'estado',
            width: 100,
            align: 'center',
            onFilter: (value, record) => record.estado === value,
            render: (estado) => {
              switch (estado) {
                case '1':
                  return <Tag color="green">Activo</Tag>;
                case '2':
                  return <Tag color="red">Inactivo</Tag>;
                default:
                  return <Tag color="default">Desconocido</Tag>;
              }
            },
          },
          {
            title: '¿Reemplazo?',
            dataIndex: 'remplazo_oid',
            key: 'remplazo',
            width: 120,
            align: 'center',
            render: (remplazo_oid) =>
              remplazo_oid
                ? <Tag color="gold">Sí</Tag>
                : <Tag color="blue">No</Tag>,
          },
          {
            title: 'Reemplaza a',
            dataIndex: 'detalle_reemplazo',
            key: 'detalle_reemplazo',
            width: 200,
            align: 'center',
            render: (detalle_reemplazo) =>
              detalle_reemplazo
                ? <Tag color="blue">{detalle_reemplazo}</Tag>
                : <Tag color="default">No aplica</Tag>,
          },
          {
            title: 'Fecha de Nacimiento',
            dataIndex: 'fecha_nacimiento',
            key: 'fecha_nacimiento',
            width: 250,
            align: 'center',
            render: (text) => formatDate(text),
          },
          {
            title: '¿Sabe leer y escribir?',
            dataIndex: 'sabe_leer_escribir',
            key: 'sabe_leer_escribir',
            width: 250,
            filterMode: 'tree',
            align: 'center'
          },
          {
            title: 'Ingresos Mensuales',
            dataIndex: 'ingresos_mensuales',
            key: 'ingresos_mensuales',
            width: 250,
            align: 'left'
          },

          {
            title: 'Línea Económica Principal',
            dataIndex: 'linea_economica',
            key: 'linea_economica',
            width: 250,
            align: 'left'
          },

          {
            title: 'Nivel de Escolaridad',
            dataIndex: 'nivel_escolaridad',
            key: 'nivel_escolaridad',
            width: 250,
            align: 'left'
          },
          {
            title: 'Ejecutado',
            dataIndex: 'Implemetador',
            key: 'Implemetador',
            width: 250,
            align: 'left',
          },
        ],
      },

      {
        title: 'POBLACIÓN',
        children: [
          {
            title: 'Campesino',
            dataIndex: 'Campesino',
            key: 'Campesino',
            width: 250,
            align: 'Center'

          },
          {
            title: 'Comunidad Indígena',
            dataIndex: 'Comunidad_Indigena',
            key: 'Comunidad_Indigena',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Comunidad NARP',
            dataIndex: 'Comunidad_NARP',
            key: 'Comunidad_NARP',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Comunidad ROM',
            dataIndex: 'Comunidad_ROM',
            key: 'Comunidad_ROM',
            width: 250,
            align: 'center'
          },
          {
            title: 'Victima',
            dataIndex: 'Victima',
            key: 'Victima',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Discapacidad',
            dataIndex: 'Discapacidad',
            key: 'Discapacidad',
            width: 250,
            align: 'Center'
          },
          {
            title: 'LGBT_plus',
            dataIndex: 'LGBT plus',
            key: 'LGBT plus',
            width: 250,
            align: 'center'
          },
          {
            title: 'Mujer rural',
            dataIndex: 'Mujer_Rural',
            key: 'Mujer_Rural',
            width: 250,
            align: 'Center'
          },

          {
            title: 'Joven rural',
            dataIndex: 'Joven_Rural',
            key: 'Joven_Rural',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Adulto mayor',
            dataIndex: 'Adulto_Mayor',
            key: 'Adulto_Mayor',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Reincorporado',
            dataIndex: 'Reincorporado',
            key: 'Reincorporado',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Otro',
            dataIndex: 'Otro',
            key: 'Otro',
            width: 250,
            align: 'Center'
          },
        ],
      },

      {
        title: 'INFORMACIÓN FAMILIAR',
        children: [
          {
            title: 'Cabeza de Familia',
            dataIndex: 'cabeza_familia',
            key: 'cabeza_familia',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Número de Personas a Cargo',
            dataIndex: 'num_personas_cargo',
            key: 'num_personas_cargo',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Total Núcleo Familiar',
            dataIndex: 'total_nucleo_familiar',
            key: 'total_nucleo_familiar',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Estado Civil',
            dataIndex: 'estado_civil',
            key: 'estado_civil',
            width: 250,
            align: 'left'
          },
          {
            title: 'Nombre del Cónyuge',
            dataIndex: 'nombre_conyuge',
            key: 'nombre_conyuge',
            width: 250,
            align: 'left'
          },
          {
            title: 'Tipo de Identificación Cónyuge',
            dataIndex: 'tipo_identificacion_conyuge',
            key: 'tipo_identificacion_conyuge',
            width: 250,
            align: 'left'
          },
          {
            title: 'Identificación Cónyuge',
            dataIndex: 'identificacion_conyuge',
            key: 'identificacion_conyuge',
            width: 250,
            align: 'left',
            filteredValue: null,
          },
          {
            title: 'Teléfono Cónyuge',
            dataIndex: 'numero_contacto_conyuge',
            key: 'numero_contacto_conyuge',
            width: 250,
            align: 'left'
          },
        ],
      },
      {
        title: 'INFORMACIÓN DEL PROYECTO VINCULADO',
        children: [
          {
            title: 'Codigo proyecto',
            dataIndex: 'codigo',
            key: 'codigo',
            width: 250,
            align: 'left',
          },
          {
            title: 'Nombre proyecto',
            dataIndex: 'proyecto',
            key: 'proyecto',
            width: 250,
            align: 'left'
          },
          {
            title: 'Subregión PDET',
            dataIndex: 'nombre_subregion_pdet',
            key: 'nombre_subregion_pdet',
            width: 250,
            align: 'left'
          },
          {
            title: 'Departamento',
            dataIndex: 'departamento',
            key: 'departamento',
            width: 250,
            sorter: {
              compare: (a, b) => a.departamento.localeCompare(b.departamento),
              multiple: 3,
            },

          },

          {
            title: 'Municipio',
            dataIndex: 'municipio',
            key: 'municipio',
            sorter: {
              compare: (a, b) => a.municipio.localeCompare(b.municipio),
              multiple: 3,
            },
            width: 250,
          },
          {
            title: 'Tipo de zona',
            width: 250,
            align: 'left',
            dataIndex: 'tipo_zona_influencia',
            key: 'tipo_zona_influencia'
          },
          {
            title: 'Nombre de zona',
            width: 250,
            align: 'left',
            dataIndex: 'nombre_zona',
            key: 'nombre_zona'
          },
          {
            title: 'Código shape veredas ART',
            width: 250,
            align: 'left',
            dataIndex: 'codigo_shape',
            key: 'codigo_shape'
          },
          {
            title: 'Nombre del Predio/Finca',
            width: 250,
            align: 'left',
            dataIndex: 'nombre_predio',
            key: 'nombre_predio'
          },
          {
            title: 'Relación de Tenencia con el Predio',
            width: 250,
            align: 'left',
            dataIndex: 'relacion_tenencia_predio',
            key: 'relacion_tenencia_predio'
          },
          {
            title: 'Latitud',
            width: 250,
            align: 'Center',
            dataIndex: 'latitud',
            key: 'latitud'
          },
          {
            title: 'Longitud',
            width: 250,
            align: 'Center',
            dataIndex: 'longitud',
            key: 'longitud'
          },
          {
            title: 'No. Hectáreas Destinadas al Proyecto',
            width: 250,
            align: 'left',
            dataIndex: 'num_hectarias_proyecto',
            key: 'num_hectarias_proyecto'
          },
          {
            title: 'Linea productiva 1',
            dataIndex: 'linea_productiva_1',
            key: 'linea_productiva_1',
            sorter: {
              compare: (a, b) => (a.linea_productiva_1 || '').localeCompare(b.linea_productiva_1 || ''),
              multiple: 3,
            },
            width: 250,
          },
          {
            title: 'Variedad establecida',
            width: 250,
            align: 'left',
            dataIndex: 'variedad_establecida',
            key: 'variedad_establecida'
          },
          {
            title: 'Línea Productiva 2',
            width: 250,
            align: 'left',
            dataIndex: 'linea_productiva_segundaria',
            key: 'linea_productiva_segundaria'
          },
          {
            title: 'Número de Hectáreas',
            dataIndex: 'num_hectareas',
            key: 'num_hectareas',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Producción anual',
            dataIndex: 'produccion_anual',
            key: 'produccion_anual',
            width: 350,
            align: 'Center'
          },
          {
            title: 'Distancia Lugar del Proyecto a Cabecera Municipal - (Kilómetros)',
            dataIndex: 'distancia_cabecera_municipal',
            key: 'distancia_cabecera_municipal',
            width: 300,
            align: 'Center'
          },
          {
            title: 'Tiempo Lugar del Proyecto a Cabecera Municipal - (Minutos)',
            dataIndex: 'tiempo_cabecera_municipal',
            key: 'tiempo_cabecera_municipal',
            width: 250,
            align: 'Center'
          },
          {
            title: 'Medio de Transporte',
            dataIndex: 'medio_transporte',
            key: 'medio_transporte',
            width: 250,
            align: 'left'
          },
          {
            title: '¿Vive en el mismo lugar del Proyecto?',
            dataIndex: 'vive_mismo_lugar',
            key: 'vive_mismo_lugar',
            width: 250,
            align: 'Center'
          },
          {
            title: '¿Lugar de Vivienda?',
            dataIndex: 'lugar_vivienda',
            key: 'lugar_vivienda',
            width: 250,
            align: 'left'
          },
        ],
      },
      {
        title: 'DATOS DE CONTACTO DEL BENEFICIARIO',
        children: [
          {
            title: 'Dirección de Correspondencia',
            dataIndex: 'direccion_correspondencia',
            key: 'direccion_correspondencia',
            width: 350,
            align: 'left'
          },
          {
            title: 'Número Telefónico 1',
            dataIndex: 'numero_telefonico_1',
            key: 'numero_telefonico_1',
            width: 150,
            align: 'left'
          },
          {
            title: 'Número Telefónico 2',
            dataIndex: 'numero_telefonico_2',
            key: 'numero_telefonico_2',
            width: 150,
            align: 'left'
          },
          {
            title: 'Correo eléctronico',
            dataIndex: 'correo_electronico',
            key: 'correo_electronico',
            width: 250,
            align: 'left'
          },

        ]
      },
      {
        title: 'CONECTIVIDAD',
        children: [
          {
            title: 'Telefónica',
            dataIndex: 'telefonica',
            key: 'telefonica',
            width: 110,
            align: 'center'
          },
          {
            title: 'Internet',
            dataIndex: 'internet',
            key: 'internet',
            width: 100,
            align: 'center'

          },

        ]
      },

      {
        title: 'INFORMACIÓN BANCARIA',
        children: [
          {
            title: 'Tipo Establecimiento Bancario cercano a su Viviendaónica',
            dataIndex: 'establemcimiento_bancario',
            key: 'establemcimiento_bancario',
            width: 250,
            align: 'center'
          },
          {
            title: '¿Cuenta con Productos Financieros?',
            dataIndex: 'cuenta_con_productos_financieros',
            key: 'cuenta_con_productos_financieros',
            width: 200,
            align: 'center'
          },
          {
            title: 'Cuenta de Ahorro',
            dataIndex: 'cuenta_de_ahorro',
            key: 'cuenta_de_ahorro',
            width: 150,
            align: 'center'
          },
          {
            title: 'Tarjeta de Crédito',
            dataIndex: 'tarjeta_de_credito',
            key: 'tarjeta_de_credito',
            width: 150,
            align: 'center'
          },
          {
            title: 'Otros Créditos ',
            dataIndex: 'otros_creditos',
            key: 'otros_creditos',
            width: 150,
            align: 'center'
          },
          {
            title: 'Tipo de entidad',
            dataIndex: 'tipo_entidad',
            key: 'tipo_entidad',
            width: 150,
            align: 'left'
          },
          {
            title: '¿Ha recibido Capacitación en Educación Financiera?',
            dataIndex: 'recibio_capacitacion_educacion_financiera',
            key: 'recibio_capacitacion_educacion_financiera',
            width: 250,
            align: 'center'
          },
          {
            title: '¿Interesado en  Información de Inclusión Financiera?',
            dataIndex: 'interesado_informacion_inclusion_financiera',
            key: 'interesado_informacion_inclusion_financiera',
            width: 250,
            align: 'left'
          },
        ]
      },
      {
        title: 'INFORMACIÓN ORGANIZACIONAL',
        children: [
          {
            title: '¿Vinculado a algúna Organización?',
            dataIndex: 'vinculado_alguna_organizacion',
            key: 'vinculado_alguna_organizacion',
            width: 200,
            align: 'left'
          },
          {
            title: 'Tipo de Organización',
            dataIndex: 'tipo_organizacion',
            key: 'tipo_organizacion',
            width: 250,
            align: 'left'
          },
          {
            title: 'Nombre de la organización',
            dataIndex: 'organizacion',
            key: 'organizacion',
            sorter: {
              compare: (a, b) => (a.organizacion || '').localeCompare(b.organizacion || ''),
              multiple: 3,
            },
            width: 150,
          },
          {
            title: 'Es una organización de Mujeres?',
            dataIndex: 'org_mujeres',
            key: 'org_mujeres',
            width: 200,
            align: 'left'
          },
        ]
      },
      {
        title: 'VALIDACIÓN INTERNA ART',
        children: [
          {
            title: '¿Validado Por Registraduría?',
            dataIndex: 'validado_registraduria',
            key: 'validado_registraduria',
            width: 150,
            align: 'Center'
          },
          {
            title: '¿Validado Por Procuraduría?',
            dataIndex: 'validado_procuraduria',
            key: 'validado_procuraduria',
            width: 150,
            align: 'Center',
          },
          {
            title: '¿Validado Por Policía?',
            dataIndex: 'validado_policia',
            key: 'validado_policia',
            width: 150,
            align: 'Center',
          },
          {
            title: 'Mediadas correctivas',
            dataIndex: 'RNMC',
            key: 'RNMC',
            width: 150,
            align: 'left',
          },
          {
            title: '¿Validado contraloria?',
            dataIndex: 'validado_contraloria',
            key: 'validado_contraloria',
            width: 150,
            align: 'left',
          }
        ]
      },
      {
        title: 'Progreso',
        dataIndex: 'progress',
        key: 'progress',
        render: (progress) => (
          <Progress
            percent={progress}
            steps={5}
            strokeColor={[
              red[5],
              red[5],
              yellow[5],
              orange[4],
              green[6]
            ]}
          />
        ),
      },
    ];



  if (loading) {
    return <div className="text-center"><Spin size="large" /></div>;
  }
  const handleCreate = () => {
    setSelectedParticipant(null);
    setModalMode("create");
    setModalOpen(true);
  };

  const handleView = (participant) => {
    setSelectedParticipant(participant);
    setModalMode("view");
    setModalOpen(true);
  };

  const handleEdit = (participant) => {
    setSelectedParticipant(participant);
    setModalMode("edit");
    setModalOpen(true);
  };



  const handleDeleteConfirm = async (oid) => {
    try {
      const response = await deleteParticipante(oid);
      if (response.status === 200) {
        message.success("Participante actualizado a Inactivo correctamente");

        // Actualizar estado localmente en lugar de eliminarlo
        const nuevosParticipantes = participantes.map(p =>
          p.oid === oid ? { ...p, estado: "2" } : p
        );

        const nuevosFiltrados = filterParticipantes.map(p =>
          p.oid === oid ? { ...p, estado: "2" } : p
        );

        setParticipantes(nuevosParticipantes);
        setFilterParticipantes(nuevosFiltrados);
      } else {
        throw new Error(response.message || "Error al actualizar estado");
      }
    } catch (error) {
      console.error("Error actualizando participante:", error);
      message.error(error.message || "Error al actualizar estado del participante");
    }
  };

  return (
    <div className={`container ${proyectoCodigo ? 'full-width' : ''}`}>
      <React.Fragment>
        {status === 404 || status === 500 ? (
          renderErrorMessage(status)
        ) : (
          <React.Fragment>
            <div className="row mb-2 d-flex align-items-center">
              <div className="col-md-8 linea_separador mb-2 d-flex align-items-center">
                <div className="titulo_proyecto" style={{ flexBasis: '25%', flexGrow: 0 }}>
                  <p>PROYECTO UTF <br /> COL 160 COL</p>
                </div>
                <div className="objeto" style={{ flexBasis: '75%', flexGrow: 0 }}>
                  <p>Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET</p>
                </div>
              </div>
              <div className="col-md-4 d-flex justify-content-center align-items-center flex-column">
                <h2 className="text-center mb-2">Listado de Participantes</h2>
                <div className="row mb-4">
                  <div className="col-md-12">
                    <div className="input-group shadow-sm">
                      {permissionExport && <ExportToExcelParticipantes data={filterParticipantes} />}


                      <Button
                        type="danger"
                        className="btn btn-primary"
                        onClick={clearAllFilters}
                        size="large"
                        icon={<ClearOutlined />}
                      >
                        Limpiar
                      </Button>
                      <Button
                        type="danger"
                        className="btn btn-primary"
                        size="large"
                        onClick={() => setShowFilters(!showFilters)}
                        icon={showFilters ? <UpOutlined /> : <DownOutlined />}
                        style={{ marginLeft: '5px', }}
                      >
                        {showFilters ? 'Ocultar filtros' : 'Mostrar filtros'}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    {showFilters && (
                      <div className="row">
                        <div className="col-md-3 mb-3">
                          <div className="form-group">
                            <label htmlFor="filterInput">Número de Identificación:</label>
                            <Input
                              type="number"
                              value={numeroIdentificacion}
                              onChange={(e) => setNumeroIdentificacion(e.target.value)}
                              id="filterInput"
                              placeholder="Ingrese un número"
                              style={{ width: '100%' }}
                            />
                          </div>
                        </div>
                        <div className="col-md-3 mb-3">
                          <div className="form-group">
                            <label htmlFor="projectSelect">departamento:</label>
                            <Select
                              showSearch
                              value={selectedDepartamento}
                              placeholder="Selecciona un departamento"
                              optionFilterProp="children"
                              onChange={(value) => handleDepartamentoChange(value)}
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              className="select-project"
                              style={{ width: '100%' }}
                            >
                              {listaDepartamentos.map((d) => (
                                <Option key={d.id_departamento} value={d.id_departamento}>
                                  {d.departamento}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-3 mb-3">
                          <div className="form-group">
                            <label htmlFor="projectSelect">Municipio:</label>
                            <Select
                              showSearch
                              placeholder="Selecciona un municipio"
                              value={selectedMunicipio}
                              optionFilterProp="children"
                              onChange={(value) => setSelectedMunicipio(value)}
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              className="select-project"
                              style={{ width: '100%' }}
                            >
                              {listaMunicipiosFilter.map((m) => (
                                <Option key={m.id_municipio} value={m.id_municipio}>
                                  {m.municipio}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-3 mb-3">
                          <div className="form-group">
                            <label htmlFor="projectSelect">Proyecto:</label>
                            <Select
                              showSearch
                              placeholder="Selecciona un proyecto"
                              value={selectedProyecto}
                              optionFilterProp="children"
                              onChange={(value) => setSelectedproyecto(value)}
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              className="select-project"
                              style={{ width: '100%' }}
                            >
                              {listaProyectos.map((proyecto) => (
                                <Option key={proyecto.proyecto_codigo} value={proyecto.proyecto_codigo}>
                                  {`${proyecto.proyecto_codigo} - ${proyecto.nombre_proyecto}`}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-3 mb-3">
                          <div className="form-group">
                            <label htmlFor="estadoSelect">Estado:</label>
                            <Select
                              showSearch
                              placeholder="Selecciona un estado"
                              value={selectedEstado}
                              optionFilterProp="children"
                              onChange={(value) => setSelectedEstado(value)}
                              allowClear
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              className="select-estado"
                              style={{ width: '100%' }}
                            >
                              {listaEstados.map((estado) => (
                                <Option key={estado.value} value={estado.value}>
                                  {estado.label}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-3 mb-3">
                          <div className="form-group">
                            <label htmlFor="implementadorSelect">Ejecutado por:</label>
                            <Select
                              showSearch
                              placeholder="Selecciona un implementador"
                              value={selectedImplementador}
                              optionFilterProp="children"
                              onChange={(value) => setSelectedImplementador(value)}
                              allowClear
                              filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                              }
                              className="select-implementador"
                              style={{ width: '100%' }}
                            >
                              {listaImplementadores.map((imple) => (
                                <Option key={imple} value={imple}>
                                  {imple}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        </div>
                        <div className="col-md-2" style={{ paddingTop: '24px', margin: '0' }}>

                          {permissionInsert && (
                            <Button
                              type="primary"
                              icon={<PlusOutlined />}
                              onClick={handleCreate}
                              size="middle"
                            >
                              Nuevo Participante
                            </Button>
                          )}
                        </div> <div className="col-md-2" style={{ paddingTop: '24px', margin: '0' }}>
                          {permissionExport && proyectoFinalActivo && participantesFinales && (
                            <ExportParticipantesFinales proyectoCodigo={proyectoFiltrar} />
                          )}
                        </div>
                      </div>
                    )}
                    <div className="participant-count-container">
                      <h1 className="participant-count-title">
                        Total Participantes: <span className="participant-count-number">{filterParticipantes.length}</span>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                {filterParticipantes.length > 0 ? (
                  viewMode === 'table' ? (
                    <Table
                      columns={columns}
                      dataSource={filterParticipantes}
                      rowKey='oid'
                      className='tablaParticipantes'
                      bordered
                      pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        onChange: (page, pageSize) => {
                          setCurrentPage(page);
                          setPageSize(pageSize);
                        },
                        showSizeChanger: true,
                      }}
                      onChange={handleTableChange}
                      sortDirections={['ascend', 'descend']}
                      sortOrder={sortOrder}
                      onSorterChange={setSortOrder}
                      sortField={sortField}
                      locale={noDataConfig}
                      loading={loading}
                      filteredInfo={filteredInfo}
                      scroll={{ y: 500, x: 'max-content' }}
                    />
                  ) : (
                    <p className="text-center">No hay participantes para mostrar.</p>
                  )
                ) : (
                  <div className="col-md-12">
                    <Alert
                      message="Sin resultados"
                      description="No hay participantes para mostrar."
                      type="info"
                      showIcon
                      className="mt-4"
                    />
                  </div>
                )}
              </div>
              <ParticipantForm
                isOpen={modalOpen}
                onClose={() => {
                  setModalOpen(false);
                  setSelectedParticipant(null);
                }}
                participant={selectedParticipant}
                onSuccess={async () => {
                  setModalOpen(false);
                  setSelectedParticipant(null);
                  await fetchPartcipantes();
                }}
                mode={modalMode}
                key={modalMode === "create" ? "create" : selectedParticipant?.oid}
              />
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    </div>
  );
};

export default Participantes;